module.exports = __webpack_public_path__ + "horizontal-darkblue-staging.png";